import dataPeriTarDaptPra from "../../../../src/data/periprocedureel-beleid-tar-dapt-asa-pra-clo-tic.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataPeriTarDaptPra,
  BasicCollapse,
  React
};